module.exports = __webpack_public_path__ + "assets/img/swiper-img3-3c441943.png";